export default __webpack_public_path__ + "static/media/electricpower2.631f12a3.jpg";